<template>
    <div class="home">
        <Hello msg="Выберите Гайд." msg_warning="Пожалуйста, используйте для проведения гайд-интервью уникальную ссылку, которую Вы получили в e-mail о назначении Вам кандидата."/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Hello from '@/components/Hello.vue'

    export default {
        name: 'home',
        components: {
            Hello
        }
    }
</script>
